import { useAppContext } from "hooks/useContext";
import type { ActiveMembershipIdsType } from "@membership/constants";

export const useMembershipIds = (): ActiveMembershipIdsType => {
  const { membershipIds } = useAppContext();
  return membershipIds;
};
